export default __webpack_public_path__ + "static/irvan-smith-5eBW5GomfhY-unsplash-b54f810826d2b58e5e7f789d85f18d72.jpg";